import * as React from "react";
import { styled } from "@mui/system";
import MUILink, { LinkProps } from "@mui/material/Link";

export const Link = styled((props: LinkProps) => <MUILink {...props} />, {
  name: "Link",
  slot: "Root",
  overridesResolver: (props, styles) => [],
})(({ theme }) => ({
  "&.MuiLink-root": {
    cursor: "pointer",
  },
}));
